<template>
  <div >
    <InputSearch class="mb-3" @clickSearch="onSearch" :search="search" :placeholder="'ค้นหา'" />
    <v-layout row wrap dense class="mb-3">
      <v-flex xs6 style="display: flex; align-items: center;">
        <Typography h2 bold label="แท็กลูกค้า" />
      </v-flex>
      <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
        <div class="text-xs-right" style="display: flex; align-items: flex-end">
          <v-btn
            variant="outlined"
            v-tooltip="'เพิ่ม'"
            :loading="loading"
            @click="showAddModal"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <img src="/static/img/Add.png" alt class="responsive-img" style="height: 20px" />
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular
        :size="100"
        :width="10"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>
    <div v-else>
      <v-data-table :headers="headers" :items="dataTag" hide-actions item-key="id">
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td class="text-xs-left" style="width: 95px;">
              <Typography :label="props.item.id" />
            </td>
            <td class="text-xs-left">
              <Typography :label="props.item.tagcustomer" />
            </td>
            <td style="width: 80px; white-space: nowrap; background: white;" @click.stop="">
              <TooltipTable
                @modalEdit="updateEditTag(props.item)"
                @Delete="deleteTagCustomer(props.item)"
                :datas="props"
                showDelete
              ></TooltipTable>
            </td>
          </tr>
        </template>
      </v-data-table>
      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :numberPage="numberPage"
        :pageCount="totalPageCount"
        :page="page"
      />
      <v-dialog v-model="addModal" persistent width="590px">
        <v-card v-if="addModal">
          <v-btn style="float: right" @click="cancelAddTagCustomer()" icon
            ><v-icon>close</v-icon></v-btn
          >
          <v-card-text
            ><Typography
              h2
              bold
              :label="`เพิ่มแท็กลูกค้า`"
              style="padding-left: 38px; margin-bottom: 22px; padding-top: 17px"
            />
          </v-card-text>
          <v-card-actions>
            <div
              style="width: 100%"
              class="form-control px-4"
              :class="{ 'has-error': errors.has('แท็กลูกค้า') }"
            >
              <label><Typography h5 semiBold color="color-darkGrey" :label="`แท็กลูกค้า`"/></label>
              <input
                type="search"
                class="depainput rsu mb-0"
                style="padding-left: 12px !important"
                name="แท็กลูกค้า"
                v-validate="'required'"
                placeholder=""
                v-model="addTag.tagcustomer"
              />
              <span class="text-error" v-if="errors.has('แท็กลูกค้า') && !duplicateAddTag">{{
                errors.first('แท็กลูกค้า')
              }}</span>
              <span class="text-error" style="color: red" v-if="duplicateAddTag">
                *มีแท็กนี้ในระบบแล้ว
              </span>
            </div>
          </v-card-actions>
          <v-card-actions style="justify-content: center" class="pb-3">
            <div class="text-xs-center rsu" style="margin-top: 30px; padding-bottom: 24px">
              <v-btn
                class="rsu"
                @click="cancelAddTagCustomer()"
                round
                small
                outline
                color="primary"
              >
                <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
              </v-btn>
              <v-btn
                class="rsu"
                @click="saveAddTagCustomer()"
                round
                small
                style="color: yellow"
                color="primary"
              >
                <Typography h5 semiBold color="color-lightYellow" :label="$t('Save')" />
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editModal" persistent width="590px">
        <v-card v-if="editModal">
          <v-btn style="float: right" @click="cancelEditTagCustomer()" icon
            ><v-icon>close</v-icon></v-btn
          >
          <v-card-text
            ><Typography
              h2
              bold
              :label="`แก้ไขแท็กลูกค้า`"
              style="padding-left: 38px; margin-bottom: 22px; padding-top: 17px"
            />
          </v-card-text>
          <v-card-actions>
            <div
              style="width: 100%"
              class="form-control px-4"
              :class="{ 'has-error': errors.has('แท็กลูกค้า') }"
            >
              <label><Typography h5 semiBold color="color-darkGrey" :label="`แท็กลูกค้า`"/></label>
              <input
                type="search"
                class="depainput rsu mb-0"
                style="padding-left: 12px !important"
                name="แท็กลูกค้า"
                v-validate="'required'"
                placeholder=""
                v-model="editTag.tagcustomer"
              />
              <span class="text-error" v-if="errors.has('แท็กลูกค้า') && !duplicateEditTag">{{
                errors.first('แท็กลูกค้า')
              }}</span>
              <span class="text-error" style="color: red; margin-top; 5px" v-if="duplicateEditTag">
                *มีแท็กนี้ในระบบแล้ว
              </span>
            </div>
          </v-card-actions>
          <v-card-actions style="justify-content: center" class="pb-3">
            <div class="text-xs-center rsu" style="margin-top: 30px; padding-bottom: 24px">
              <v-btn
                class="rsu"
                @click="cancelEditTagCustomer()"
                round
                small
                outline
                color="primary"
              >
                <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
              </v-btn>
              <v-btn
                class="rsu"
                @click="saveEdiTagCustomer()"
                round
                small
                style="color: yellow"
                color="primary"
              >
                <Typography h5 semiBold color="color-lightYellow" :label="$t('Save')" />
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import header from '@/components/elements/header'
import Template from '../template/template.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Paginations from '@/components/elements/Paginations.vue'
import api from '@/api'
export default {
  components: {
    InputSearch,
    Typography,
    TooltipTable,
    Paginations
  },
  data() {
    return {
      search: { nameAll: '' },
      loading: false,
      tagTotal: 0,
      page: 1, // กำหนดหน้าปัจจุบัน
      itemsPerPage: 12, // กำหนดจำนวนข้อมูลที่แสดงในแต่ละหน้า
      numberPage: {
        page: undefined
      },
      addTag: {
        tagcustomer: ''
      },
      duplicateAddTag: false,
      addModal: false,

      editTag: {},
      editModal: false,
      duplicateEditTag: false,

      headers: [
        {
          text: 'ID',
          value: 'index',
          align: 'left',
          sortable: false
        },
        {
          text: 'แท็กลูกค้า',
          value: 'tagcustomer',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: '',
          align: 'left',
          sortable: false
        }
      ],
      newTag: {
        id: '',
        name: ''
      },
      dataTag: []
    }
  },
  async mounted() {
    this.loading = true
    const { data, total } = await this.getTagCustomer()
    this.tagTotal = total
    this.dataTag = data.map((item, idx) => ({
      index: idx + 1,
      id: item.id,
      tagcustomer: item.tagcustomer
    }))
    this.loading = false
  },
  computed: {
    totalPageCount() {
      if (this.tagTotal !== 0) {
        return Math.ceil(this.tagTotal / this.itemsPerPage)
      } else {
        return 0
      }
    }
  },
  methods: {
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      const { data, total } = await this.getTagCustomer()
      this.tagTotal = total
      this.dataTag = data.map((item, idx) => ({
        index: idx + 1,
        id: item.id,
        tagcustomer: item.tagcustomer
      }))
      this.loading = false
    },
    async sortPage(pages) {
      if (pages == '' || +pages <= 0 || +pages > this.totalPageCount) return
      this.page = parseInt(pages)
      this.loading = true
      const { data, total } = await this.getTagCustomer()
      this.tagTotal = total
      this.dataTag = data.map((item, idx) => ({
        index: idx + 1,
        id: item.id,
        tagcustomer: item.tagcustomer
      }))
      this.loading = false
    },
    async onSearch() {
      this.loading = true
      this.page = 1
      this.numberPage.page = 1
      const { data, total } = await this.getTagCustomer()
      this.tagTotal = total
      this.dataTag = data.map((item, idx) => ({
        index: idx + 1,
        id: item.id,
        tagcustomer: item.tagcustomer
      }))
      this.loading = false
    },
    async onUpdate() {
      this.loading = true
      const { data, total } = await this.getTagCustomer()
      this.tagTotal = total
      this.dataTag = data.map((item, idx) => ({
        index: idx + 1,
        id: item.id,
        tagcustomer: item.tagcustomer
      }))
      this.loading = false
    },
    async getTagCustomer() {
      try {
        const data = {
          limit: this.itemsPerPage,
          offset: (this.page - 1) * this.itemsPerPage,
          tagcustomer: this.search.nameAll
        }
        return await api.getTagCustomer(data)
      } catch (e) {
        console.log(e)
      }
    },
    async saveAddTagCustomer() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        try {
          const { data } = await api.addTagCustomer(this.addTag)
          if (data.responsecode == 300 || data.message == 'This Tagcustomer is exist') {
            this.duplicateAddTag = true
          } else if (data.responsecode == 200) {
            this.duplicateAddTag = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            this.cancelAddTagCustomer()
            await this.onUpdate()
          } else if (data.responsecode == 305) {
            this.$swal.fire({
              type: 'error',
              title:
                '<div class="headline primary--text bold7 fs-24">ไม่สามารถแก้ไขข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้แท็กลูกค้านี้อยู่</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            this.cancelAddTagCustomer()
            await this.onUpdate()
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    async saveEdiTagCustomer() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        try {
          const { data } = await api.editTagCustomer(this.editTag)
          if (data.responsecode == 300 || data.message == 'This Tagcustomer is exist') {
            this.duplicateEditTag = true
          } else if (data.responsecode == 200) {
            this.duplicateEditTag = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            await this.onUpdate()
            this.cancelEditTagCustomer()
          } else if (data.responsecode == 305) {
            this.$swal.fire({
              type: 'error',
              title:
                '<div class="headline primary--text bold7 fs-24">ไม่สามารถแก้ไขข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้แท็กลูกค้านี้อยู่</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            this.cancelEditTagCustomer()
            await this.onUpdate()
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    async deleteTagCustomer(item) {
      const res = await api.checkTagcustomer({ tagcustomer: item.tagcustomer })
      if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          title: `<div class="headline primary--text bold7 fs-24">ไม่สามารถแก้ไขข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้ตราสัญลักษณ์นี้อยู่</div>`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      } else {
        this.$swal
          .fire({
            title:
              '<img src="/static/img/delete.png" alt class="responsive-img mt-4" style="height: 73px" />',
            html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">คุณต้องการลบแท็กลูกค้านี้ใช่หรือไม่</div>`,
            showCancelButton: true,
            showCloseButton: true
          })
          .then(async result => {
            if (result.value) {
              let res = await api.deleteTagCustomer(item.id)
              if (this.dataTag.length == 1) {
                if (this.page != 1) {
                  this.page = this.page - 1
                  this.numberPage.page = this.page - 1
                }
              }
              console.log(this)
              console.log('res', res)
              if (res.responsecode == 200) {
                await this.onUpdate()
                this.$swal.fire({
                  type: 'success',
                  title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              } else {
                this.$swal.fire({
                  type: 'error',
                  title:
                    '<div class="headline primary--text bold7 fs-24">ไม่สามารถลบข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้ตราสัญลักษณ์นี้อยู่</div>',
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              }
            }
          })
      }
    },
    showAddModal() {
      if (!this.addModal) {
        this.addModal = true
      }
    },
    cancelAddTagCustomer() {
      this.addModal = false
      this.addTag.tagcustomer = ''
      this.duplicateAddTag = false
    },
    cancelEditTagCustomer() {
      this.editModal = false
      this.editTag.id = ''
      this.editTag.tagcustomer = ''
      this.editTag.index = ''
    },
    async updateEditTag(item) {
      const res = await api.checkTagcustomer({ tagcustomer: item.tagcustomer })
      if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          title: `<div class="headline primary--text bold7 fs-24">ไม่สามารถแก้ไขข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้ตราสัญลักษณ์นี้อยู่</div>`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      } else {
        this.editModal = true
        this.editTag = {
          ...item
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectCustomer.vue